<template>
  <li class="accordion-item">
    <div class="accordion-item-wrapper">
      <div class="accordion-item-trigger" :class="{ accordion__trigger_active: visible }" @click="open">
        <slot name="accordion-trigger"></slot>
      </div>
      <slot name="accordion-no-trigger"></slot>
    </div>

    <transition
      name="accordion"
      @before-enter="start"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end">
      <div v-show="visible">
        <slot name="accordion-content"></slot>
      </div>
    </transition>
  </li>
</template>

<script>
  import { computed, ref, inject } from "@vue/composition-api";
  export default {
    props: {
      active: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    setup(props) {
      let index = ref(null);
      const accordionInject = inject("accordion");
      index.value = accordionInject.count++;
      const visible = computed(() => {
        return index.value === accordionInject.active;
      });
      if (props.active) {
        accordionInject.active = index.value;
      }
      const open = () => {
        if (visible.value) {
          accordionInject.active = null;
        } else {
          accordionInject.active = index.value;
        }
      };
      const start = (el) => {
        el.style.height = el.scrollHeight + "px";
      };
      const end = (el) => {
        el.style.height = "";
      };

      return {
        index,
        visible,
        open,
        start,
        end,
      };
    },
  };
</script>

<style lang="scss">
  .accordion-enter-active,
  .accordion-leave-active {
    will-change: height, opacity;
    transition: height 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
  }

  .accordion-enter,
  .accordion-leave-to {
    height: 0 !important;
    opacity: 0;
  }

  .accordion-item {
    background-color: white;
    padding: 16px;
    border-radius: 6px;
    margin-bottom: 12px;

    &-wrapper {
      display: flex;
      align-items: center;
    }

    &-trigger {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }
</style>
